import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../components/lib/UI/loadingSpinner/LoadingSpinner';
import { useAppSelector } from 'setup/store';
import ErrorBox from 'components/lib/error-box';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import StoreDataForm from 'components/store/store-data-form/StoreDataForm';

const StoreDetailsPage = () => {
  const { t } = useTranslation();
  const params = useParams();
  const storeId = params && params.storeId ? Number(params.storeId) : undefined;

  const loading = useAppSelector((store) => store.userReducer.loading);
  const error = useAppSelector((store) => store.userReducer.error);

  let customerTable;

  if (loading) {
    customerTable = <LoadingSpinner />;
  }

  return (
    <section style={{ marginBottom: '80px' }}>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2} className="pageTitleTitleContainer">
        <h2 className="pageTitle">{t('page.storeDetails')}</h2>
      </Box>
      {error ? <ErrorBox title="Error" message={error.msg} /> : null}
      <StoreDataForm storeId={storeId} />
    </section>
  );
};

export default StoreDetailsPage;
